/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AmsBookingStatus } from './AmsBookingStatus';
import {
    AmsBookingStatusFromJSON,
    AmsBookingStatusFromJSONTyped,
    AmsBookingStatusToJSON,
    AmsBookingStatusToJSONTyped,
} from './AmsBookingStatus';

/**
 * 
 * @export
 * @interface AmsBookingResponse
 */
export interface AmsBookingResponse {
    /**
     * 
     * @type {string}
     * @memberof AmsBookingResponse
     */
    id: string;
    /**
     * 
     * @type {AmsBookingStatus}
     * @memberof AmsBookingResponse
     */
    status: AmsBookingStatus;
    /**
     * 
     * @type {string}
     * @memberof AmsBookingResponse
     */
    message: string | null;
}



/**
 * Check if a given object implements the AmsBookingResponse interface.
 */
export function instanceOfAmsBookingResponse(value: object): value is AmsBookingResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function AmsBookingResponseFromJSON(json: any): AmsBookingResponse {
    return AmsBookingResponseFromJSONTyped(json, false);
}

export function AmsBookingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AmsBookingResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'status': AmsBookingStatusFromJSON(json['status']),
        'message': json['message'],
    };
}

export function AmsBookingResponseToJSON(json: any): AmsBookingResponse {
    return AmsBookingResponseToJSONTyped(json, false);
}

export function AmsBookingResponseToJSONTyped(value?: AmsBookingResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'status': AmsBookingStatusToJSON(value['status']),
        'message': value['message'],
    };
}

